import { render, staticRenderFns } from "./Vdr.vue?vue&type=template&id=4a95b447&scoped=true"
import script from "./Vdr.vue?vue&type=script&lang=js"
export * from "./Vdr.vue?vue&type=script&lang=js"
import style0 from "./Vdr.vue?vue&type=style&index=0&id=4a95b447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a95b447",
  null
  
)

export default component.exports